/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * What lifecycle event a Compliance.Forms.Models.Forms.History.FormDefinitionChange records.
 */
export enum FormDefinitionChangeKind {
    CREATED = 'Created',
    UPDATED = 'Updated',
    DRAFT_STARTED = 'DraftStarted',
    DRAFT_EDITED = 'DraftEdited',
    DRAFT_COMMITTED = 'DraftCommitted',
    DRAFT_DISCARDED = 'DraftDiscarded',
}
